/* eslint-disable-next-line no-undef */
module.exports = require(process.env.NODE_ENV === 'production' ? './configure-store.prod' : './configure-store.dev');
